import {Component, EventEmitter, inject, Output, Signal, ViewChild, ViewContainerRef} from '@angular/core';
import {SidebarComponent} from '../../shared/toolbox/sidebar/sidebar.component';
import {RankingsComponent} from './elements/rankings/rankings.component';
import {toSignal} from '@angular/core/rxjs-interop';
import {BehaviorSubject, map} from 'rxjs';
import {NgForOf, NgIf, NgOptimizedImage} from '@angular/common';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {CompanyMetricsComponent} from './elements/company-metrics/company-metrics.component';
import {RetailerSectionComponent} from './elements/retailer-section/retailer-section.component';
import {RetailerProfileInterface, retailerShortInterface} from './dashboard.interface';
import {MatGridListModule} from '@angular/material/grid-list';
import {IconCardComponent} from './elements/icon-card/icon-card.component';
import {CompanyGeneralInfoComponent} from './elements/company-general-info/company-general-info.component';
import {MatButtonModule} from '@angular/material/button';
import {faPlus, faShareNodes, faUpload} from '@fortawesome/free-solid-svg-icons';
import {IconProp} from '@fortawesome/fontawesome-svg-core';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {EchelonComponent} from '../../shared/toolbox/echelon/echelon.component';
import {ActivatedRoute, Router} from '@angular/router';
import {LoaderComponent} from '../../shared/toolbox/loader/loader.component';
import {MediaQueryService} from '../../services/media-query/media-query.service';
import {gutterSizer, rowSizer} from './dahsboard.utils';
import {
  MobileCompanyGeneralInfoComponent
} from './elements/mobile-company-general-info/mobile-company-general-info.component';
import {CompanyProfileComponent} from '../../shared/toolbox/charts/company-profile/company-profile.component';
import {ToolboxModule} from '../../shared/toolbox/toolbox.module';
import {DialogComponent} from '../../shared/toolbox/dialogs/dialog/dialog.component';
import { CompareDialogComponent } from 'src/app/shared/toolbox/dialogs/compare-dialog/compare-dialog.component';
import { DashboardService } from 'src/app/services/dashboard/dashboard.service';
import { environment } from 'src/environments/environment';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EditOverlayComponent } from './elements/edit-overlay/edit-overlay.component';
import { LbFullWidthDropdownComponent } from "../../lbarometer/shared/lb-full-width-dropdown/lb-full-width-dropdown.component";
import {LbChartEchelonComponent} from "../../lbarometer/toolbox/lb-chart-echelon/lb-chart-echelon.component";
import { RxAuthService } from 'src/app/services/rx-auth/rx-auth.service';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  imports: [
    SidebarComponent,
    RankingsComponent,
    NgIf,
    MatProgressSpinnerModule,
    CompanyMetricsComponent,
    RetailerSectionComponent,
    MatGridListModule,
    IconCardComponent,
    NgOptimizedImage,
    CompanyGeneralInfoComponent,
    MatButtonModule,
    FontAwesomeModule,
    EchelonComponent,
    NgForOf,
    LoaderComponent,
    MobileCompanyGeneralInfoComponent,
    DialogComponent,
    CompareDialogComponent,
    MatTooltipModule,
    LbFullWidthDropdownComponent,
    LbChartEchelonComponent,
    ToolboxModule,

  ],
  standalone: true
})
export class DashboardComponent {
  constructor(
  public auth :RxAuthService
){}
  @ViewChild('companyProfileContainer', {read:ViewContainerRef}) companyProfileContainer!: ViewContainerRef;
  @Output() compareTo: EventEmitter<any> = new EventEmitter

  private actRout: ActivatedRoute = inject(ActivatedRoute);
  private mediaService: MediaQueryService = inject(MediaQueryService);
  public rankingData: Signal<RetailerProfileInterface> = toSignal(this.actRout.data.pipe(map(({profileData}) => profileData)));
  public gutterSizing: Signal<string> = toSignal(this.mediaService.getDisplayType().pipe(map(gutterSizer)), {initialValue: '0'});
  public rowSizing: Signal<string> = toSignal(this.mediaService.getDisplayType().pipe(map(rowSizer)), {initialValue: '0'});
  public isMobile: Signal< boolean > = toSignal(this.mediaService.getDisplayType().pipe(map(({isMobile}) => isMobile)), {initialValue: window.innerWidth < 768});

  public shareIcon = faShareNodes as IconProp;
  public uploadIcon = faUpload as IconProp;
  public plusIcon = faPlus as IconProp;

  public displayDialog:boolean = false;
  public showCompareDialog:boolean = false;
  public profileURL: string =''

  public dashboardService = inject(DashboardService)
  public router = inject(Router)

  public isInList:boolean = this.rankingData().current_list ? true : false;
  public comparedAgainst:BehaviorSubject<retailerShortInterface|null> = new BehaviorSubject<retailerShortInterface|null>(null)

  public dropdownName: string = 'Other information';
  public dropdownStates: { [key: string]: boolean } = {dropdownName: false};


  ngOnInit() {
    this.profileURL = `${(environment.frontend_base)}${(this.router.url).split('/')[1]}`;

    this.dashboardService.setProfile(this.rankingData())
    // console.log(this.actRout.snapshot.queryParamMap.get('compare'))
    if (this.actRout.snapshot.queryParamMap.get('compare')){

      this.comparedAgainst.next({name:this.rankingData().compared_against!.name, rcl:this.rankingData().compared_against!.rcl})
      this.compareTo.emit()
      this.dashboardService.compareEmit()
    }


  }

  toggleShareDialog() {
    this.displayDialog = !this.displayDialog
  }

  toggleCompareDialog() {
    this.showCompareDialog = !this.showCompareDialog
    if (!this.showCompareDialog && this.actRout.snapshot.queryParamMap.get('compare')) {
     this.compare()

    }
  }

  compare() {
    this.compareTo.emit()
    this.comparedAgainst.next(this.dashboardService.getCompareAgainst())
    this.dashboardService.compareEmit()
  }


  downloadCompanyProfile(retailerProfile: any) {
    const componentRef = this.companyProfileContainer.createComponent(CompanyProfileComponent)

    componentRef.instance.rcl = retailerProfile.retailer.base_rcl

    componentRef.instance.isReadyObservable.subscribe((ready:any) => { //Wait for the component to get the data from backend
      if (ready === true) {

        setTimeout(() => { //Wait for the component data to be rendered.

          const htmlContent = componentRef.location.nativeElement.outerHTML;


          const componentStyles = this.getComponentStyles(componentRef)
          const globalStyles = this.getGlobalStyles()

          // Inject the styles into the HTML
          const fullHtml = `
            <html>
              <head>
                <style>${globalStyles}</style>
                <style>${componentStyles}</style>
              </head>
              <body>${htmlContent}</body>
            </html>
          `;

          this.downloadfile(fullHtml, retailerProfile)

          componentRef.destroy()
        }, 100)
      }
    })



  }

  getComponentStyles(component:any) {
    const componentSelector = Reflect.getMetadata('annotations', component)

    let styles = '';

    // Traverse all stylesheets to find rules associated with the component
    const styleSheets = Array.from(document.styleSheets) as CSSStyleSheet[];
    styleSheets.forEach((sheet) => {
      try {
        const rules = sheet.cssRules || sheet.rules;
        Array.from(rules).forEach((rule) => {
          if (rule.cssText.includes(componentSelector)) {
            styles += rule.cssText;
          }
        });
      } catch (error) {
        console.warn('Error loading stylesheet:', sheet.href);
      }
    });

    return styles;
  }

  getGlobalStyles() {
    let globalStyles = '';

    const styleSheets = Array.from(document.styleSheets) as CSSStyleSheet[];
    styleSheets.forEach((sheet) => {
      try {
        const rules = sheet.cssRules || sheet.rules;
        Array.from(rules).forEach((rule) => {
          // Assume global styles are not scoped by a component selector
          if (!rule.cssText.includes('[_ngcontent]')) {
            globalStyles += rule.cssText;
          }
        });
      } catch (error) {
        console.warn('Error loading stylesheet:', sheet.href);
      }
    });

    return globalStyles;
  }

  downloadfile(htmlContent:any, retailerProfile: any) {
    const blob = new Blob([htmlContent], { type: 'text/html' });


    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `${retailerProfile.retailer.name} Company Profile.html`;
    link.click();
  }

  redirectToBaseRCL(baseRCL:number) {
    let url = `${environment.frontend_base}profile?id=${baseRCL}`
    window.location.href = url
    //this.router.navigateByUrl(url)
  }

  navigateToRCL(rcl:number) {
    let url = `${environment.frontend_base}profile?id=${rcl}`
    window.location.href = url
  }
  echelonShowPadlock(companyInfo:any){
    // console.log(companyInfo)
    if (this.auth.isPremiumUser() || this.auth.isEssentialUser()) {
      return false
    } else if (this.auth.isBasicUser()) {
        return !companyInfo.other_lists.some((list:any) => {return list.region.code === 'GB' && list.name.includes('UK500') && list.cluster === "Elite"})
    }
    return true
  }

}
